// extracted by mini-css-extract-plugin
export var container = "Container-module--container--662b9";
export var fullMobile = "Container-module--fullMobile--dcf66";
export var large = "Container-module--large--b6fcf";
export var medium = "Container-module--medium--2ff18";
export var min = "Container-module--min--065b0";
export var none = "Container-module--none--a990f";